import { memo, FC, useState, useEffect, useMemo } from 'react'

import { useSetFocus } from '@please/lrud'
import { Element, scroller } from 'react-scroll'

import { focusIds } from '@/constants/focus'
import { scrollOptions } from '@/constants/scrollers'
import { PrivacySettingsTabContent } from '@/containers/Usercentrics/PrivacySettingsTabContent'
import { useCustomFocus } from '@/hooks/useCustomFocus'
import {
  PrivacySettingsProps,
  SecondLayerLabels,
} from '@/types/componentsPropsTypes'

import { TabElem, TabsRow } from './styles'

export enum privacySettingsTab {
  PURPOSES_TAB = 'purposesTab',
  VENDOR_TAB = 'vendorsTab',
  CATEGORY_TAB = 'categoryTab',
  SERVICE_TAB = 'serviceTab',
}

const tcfPrivacySettingsTabs = [
  privacySettingsTab.PURPOSES_TAB,
  privacySettingsTab.VENDOR_TAB,
]

const defaultPrivacySettingsTabs = [
  privacySettingsTab.CATEGORY_TAB,
  privacySettingsTab.SERVICE_TAB,
]

const PrivacySettingsRaw: FC<PrivacySettingsProps> = ({
  defaultLabels,
  servicesDecision,
  tcfUserDecisions,
  setServicesDecision,
  setTcfUserDecisions,
  privacyRegulation,
}) => {
  const focusId = `${focusIds.USERCENTRICS}_tabs`
  const setFocus = useSetFocus()

  const { defaultFocusChild, onMove } = useCustomFocus({ focusId })

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)

  useEffect(() => {
    setTimeout(setFocus, 0, `${focusIds.USERCENTRICS}_container`)
  }, [])

  const privacySettingsTabs = useMemo(() => {
    return privacyRegulation === 'Tcf'
      ? tcfPrivacySettingsTabs
      : defaultPrivacySettingsTabs
  }, [privacyRegulation])

  return (
    <>
      <Element
        key={focusId}
        name={focusId}
        style={{ position: 'sticky', top: '0', zIndex: 10 }}
      >
        <TabsRow
          elementType="section"
          focusId={focusId}
          defaultFocusChild={defaultFocusChild}
          onMove={onMove}
          onFocused={() =>
            scroller.scrollTo(focusId, {
              ...scrollOptions.UsercentricsScroll,
              offset: -scrollOptions.UsercentricsScroll.height,
            })
          }
        >
          {privacySettingsTabs.map((tab, index) => {
            const title = defaultLabels?.[
              tab as keyof SecondLayerLabels
            ] as string
            return (
              <TabElem
                key={`${focusIds.USERCENTRICS}_${title}_${index}`}
                focusId={`${focusIds.USERCENTRICS}_${title}_${index}`}
                onSelected={() => setActiveTabIndex(index)}
                $activeTab={activeTabIndex === index}
              >
                {title}
              </TabElem>
            )
          })}
        </TabsRow>
      </Element>
      {privacySettingsTabs.map((tab, index) => {
        const title = defaultLabels?.[tab as keyof SecondLayerLabels] as string
        return (
          <PrivacySettingsTabContent
            key={`TabContent_${title}`}
            isActiveTabContent={activeTabIndex === index}
            tabContentType={tab}
            tabTitle={title}
            servicesDecision={servicesDecision}
            setServicesDecision={setServicesDecision}
            tcfUserDecisions={tcfUserDecisions}
            setTcfUserDecisions={setTcfUserDecisions}
          />
        )
      })}
    </>
  )
}

export const PrivacySettings = memo(PrivacySettingsRaw)
